var $b272932a685e8482$exports = {};
$b272932a685e8482$exports = {
  "decrease": function decrease(args) {
    return "Zn\xED\u017Ei\u0165 ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "Zv\xFD\u0161i\u0165 ".concat(args.fieldLabel);
  },
  "numberField": "\u010C\xEDseln\xE9 pole"
};
export { $b272932a685e8482$exports as default };